<template>
  <div id="information">
    <Header @update="handleUpdate"></Header>
    <NewsList :key="newsList"></NewsList>
    <!--<CooperativePartner></CooperativePartner>-->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header";
import NewsList from "../components/News/NewsList";
import Footer from "../components/Footer";
export default {
  name: "Information",
  components: {
    Header,
    NewsList,
    Footer
  },
  data() {
    return {
      newsList: 1
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  methods: {
    handleUpdate() {
      this.newsList++;
    }
  }
};
</script>

<style scoped>
#information {
  background: #ffffff;
}
</style>
